
import { ImageIcon } from 'lucide-react';

const NoImage = ({
  className = "",
  title = "Resim Yok",
  description = "Bu içerik için resim bulunmuyor",
  showIcon = true,
  showText = true
}) => {
  return (
    <div className={`bg-gradient-to-br from-slate-100 via-gray-100 to-slate-200 flex flex-col items-center justify-center text-gray-500 border border-gray-200 ${className}`}>
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-5">
        <div className="w-full h-full" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: '30px 30px'
        }} />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center">
        {showIcon && (
          <div className="bg-white/80 backdrop-blur-sm rounded-full p-3 mb-3 shadow-sm">
            <ImageIcon className="w-8 h-8 text-gray-400" />
          </div>
        )}
        {showText && (
          <div className="text-center px-4">
            <p className="font-medium text-gray-600 mb-1 text-sm">{title}</p>
            <p className="text-xs text-gray-500 leading-relaxed">{description}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NoImage;
